import { supabase } from "./supabase";

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  return navigator.serviceWorker.register("/sw.js");
}

export async function requestNotifications() {
  if (!("Notification" in window)) return { ok: false, message: "Notifications are not supported in this browser." };
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { ok: false, message: `Notification permission is ${permission}.` };

  const registration = await navigator.serviceWorker.ready;
  const apiBase = import.meta.env.VITE_API_BASE_URL as string | undefined;
  const publicKey = (import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined) ?? (await fetchVapidPublicKey(apiBase));
  if (publicKey && "PushManager" in window) {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey)
    });
    if (apiBase) {
      const token = (await supabase?.auth.getSession())?.data.session?.access_token;
      if (!token) return { ok: false, message: "Sign in with Supabase before saving remote Web Push subscriptions." };
      const response = await fetch(`${apiBase}/push/subscribe`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${token}`
        },
        body: JSON.stringify(subscription)
      });
      if (!response.ok) return { ok: false, message: "Could not save Web Push subscription." };
    }
    return { ok: true, message: "Web Push subscription saved." };
  }

  registration.showNotification("TradeSignal notifications enabled", {
    body: "This device can receive local PWA notifications. Add VAPID keys for Web Push.",
    icon: "/icons/icon-192.svg"
  });
  return { ok: true, message: "Local notification test sent. Configure VAPID keys for remote Web Push." };
}

async function fetchVapidPublicKey(apiBase?: string) {
  if (!apiBase) return undefined;
  const response = await fetch(`${apiBase}/settings/vapid-public-key`);
  if (!response.ok) return undefined;
  const body = (await response.json()) as { publicKey?: string | null };
  return body.publicKey ?? undefined;
}

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
